module.exports = __webpack_public_path__ + "static/media/money.6fa510a1.png";